/**
 *
 * @module mediaManagerExtrasMap
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';

/**
 *
 * @class MediaManagerExtrasMap
 * @desc Provides additional configuration information used by the manager.
 *
 */
export default class MediaManagerExtrasMap {

    /**
     *
     * @param {Object} playbackSession
     * @param {String} playbackScenarioDefault
     * @param {Boolean} [cookieEnabled=false]
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(playbackSession, playbackScenarioDefault, cookieEnabled = false, logger = Logging) {

        const errorMessage = {
            ctor: 'MediaManagerExtrasMap(playbackSession, playbackScenarioDefault, logger)',
            get playbackSession() {
                return `${this.ctor} playbackSession should be a non-empty Object`;
            },
            get playbackScenarioDefault() {
                return `${this.ctor} playbackScenarioDefault should be a String with length`;
            }
        };

        if (Check.not.nonEmptyObject(playbackSession)) {
            logger.warn('MediaManagerExtrasMap', errorMessage.playbackSession);
        }

        if (Check.not.nonEmptyString(playbackScenarioDefault)) {
            logger.warn('MediaManagerExtrasMap', errorMessage.playbackScenarioDefault);
        }

        /**
         *
         * @access public
         * @type {Object}
         * @desc Gets or sets configuration that applies to each playback session.
         *
         */
        this.playbackSession = playbackSession;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the default playback scenario for the playform.
         *
         */
        this.playbackScenarioDefault = playbackScenarioDefault;

        /**
         *
         * @access public
         * @type {Boolean}
         * @desc Gets or sets flag to enable cookies.
         *
         */
        this.cookieEnabled = cookieEnabled;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/mediaManagerExtrasMap.js